module.exports = __webpack_public_path__ + "img/upload-logo.c221d5c0.svg";